import * as React from "react";

function SvgHIPAABadgeSolid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width="117px"
      height="24px"
      viewBox="0 0 117 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <title>hipaa_badge_2</title>
      <g
        id="Dashboard"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Hippa_mode_5" transform="translate(-700.000000, -21.000000)">
          <g id="hipaa_badge_2" transform="translate(700.000000, 21.000000)">
            <polygon
              id="Path"
              fill="#FEFEFE"
              fillRule="nonzero"
              points="30.8536368 7.62630193 30.8536368 11.3587238 35.4556875 11.3587238 35.4556875 7.62630193 37.1695547 7.62630193 37.1695547 16.4939777 35.4556875 16.4939777 35.4556875 12.7488605 30.8536368 12.7488605 30.8536368 16.4939777 29.1397696 16.4939777 29.1397696 7.62630193"
            ></polygon>
            <polygon
              id="Path"
              fill="#FEFEFE"
              fillRule="nonzero"
              points="41.6412919 7.62630193 41.6412919 16.4939777 39.9274247 16.4939777 39.9274247 7.62630193"
            ></polygon>
            <path
              d="M47.8268962,7.62630193 C48.6563233,7.62630193 49.3302328,7.86645492 49.8486247,8.34676091 C50.3670166,8.8270669 50.6262126,9.44596338 50.6262126,10.2034504 C50.6262126,10.9694009 50.3638428,11.5893553 49.8391032,12.0633136 C49.3143636,12.537272 48.6224691,12.7742511 47.7634196,12.7742511 L46.113029,12.7742511 L46.113029,16.4939777 L44.3991618,16.4939777 L44.3991618,7.62630193 L47.8268962,7.62630193 Z M47.4016032,11.4348957 C47.8586345,11.4348957 48.2151612,11.3301593 48.4711833,11.1206867 C48.7272054,10.911214 48.8552165,10.6012368 48.8552165,10.1907551 C48.8552165,9.37402328 48.3304769,8.9656574 47.2809977,8.9656574 L46.113029,8.9656574 L46.113029,11.4348957 L47.4016032,11.4348957 Z"
              id="Shape"
              fill="#FEFEFE"
              fillRule="nonzero"
            ></path>
            <path
              d="M56.4690435,7.62630193 L60.3855474,16.4939777 L58.5764653,16.4939777 L57.6560552,14.3357746 L53.7141607,14.3357746 L52.8572271,16.4939777 L51.0608403,16.4939777 L54.7170903,7.62630193 L56.4690435,7.62630193 Z M54.2346685,13.0345051 L57.0974614,13.0345051 L55.5994146,9.52425115 L54.2346685,13.0345051 Z"
              id="Shape"
              fill="#FEFEFE"
              fillRule="nonzero"
            ></path>
            <path
              d="M66.6854095,7.62630193 L70.6019134,16.4939777 L68.7928314,16.4939777 L67.8724212,14.3357746 L63.9305267,14.3357746 L63.0735931,16.4939777 L61.2772064,16.4939777 L64.9334564,7.62630193 L66.6854095,7.62630193 Z M64.4510345,13.0345051 L67.3138275,13.0345051 L65.8157806,9.52425115 L64.4510345,13.0345051 Z"
              id="Shape"
              fill="#FEFEFE"
              fillRule="nonzero"
            ></path>
            <polygon
              id="Path"
              fill="#FEFEFE"
              fillRule="nonzero"
              points="78.3266377 7.62630193 81.2402119 11.1238605 84.1537861 7.62630193 85.6835713 7.62630193 85.6835713 16.4939777 83.9697041 16.4939777 83.9697041 10.2669269 83.9189228 10.2669269 81.3544697 13.3899738 81.1132588 13.3899738 78.5488057 10.2669269 78.4980244 10.2669269 78.4980244 16.4939777 76.7841572 16.4939777 76.7841572 7.62630193"
            ></polygon>
            <path
              d="M92.9482772,7.51204411 C93.8665714,7.51204411 94.6928247,7.70141586 95.4270369,8.08015935 C96.1612492,8.45890284 96.7462915,9.00480128 97.1821639,9.71785466 C97.6180363,10.430908 97.8359725,11.2127277 97.8359725,12.0633136 C97.8359725,12.8927407 97.623326,13.6618651 97.198033,14.3706867 C96.7727401,15.0795083 96.1887557,15.6296385 95.4460799,16.0210773 C94.7034041,16.4125161 93.8665714,16.6082355 92.9355818,16.6082355 C92.0172876,16.6082355 91.1825708,16.4093423 90.4314315,16.0115558 C89.6802921,15.6137694 89.0952498,15.066813 88.6763045,14.3706867 C88.2573592,13.6745604 88.0478865,12.905436 88.0478865,12.0633136 C88.0478865,11.2508136 88.2573592,10.486979 88.6763045,9.77180974 C89.0952498,9.05664047 89.6728865,8.50122055 90.4092147,8.10554997 C91.1455428,7.7098794 91.991897,7.51204411 92.9482772,7.51204411 Z M89.8188826,12.0633136 C89.8188826,12.6515298 89.9521834,13.1805011 90.218785,13.6502277 C90.4853865,14.1199543 90.8567244,14.4838866 91.3327986,14.7420246 C91.8088729,15.0001626 92.3473657,15.1292316 92.9482772,15.1292316 C93.8581079,15.1292316 94.6060734,14.8435871 95.1921736,14.272298 C95.7782739,13.701009 96.071324,12.9646808 96.071324,12.0633136 C96.071324,11.4750975 95.9390812,10.9450682 95.6745955,10.4732258 C95.4101098,10.0013833 95.037714,9.63639307 94.557408,9.37825505 C94.077102,9.12011703 93.5364933,8.99104802 92.9355818,8.99104802 C92.3346704,8.99104802 91.7940617,9.12117497 91.3137557,9.38142888 C90.8334497,9.64168279 90.4642277,10.0056151 90.2060897,10.4732258 C89.9479516,10.9408364 89.8188826,11.4708657 89.8188826,12.0633136 Z"
              id="Shape"
              fill="#FEFEFE"
              fillRule="nonzero"
            ></path>
            <path
              d="M103.920014,7.62630193 C104.84254,7.62630193 105.663504,7.81461573 106.382905,8.19124333 C107.102306,8.56787094 107.6609,9.09684229 108.058686,9.7781574 C108.456473,10.4594725 108.655366,11.225423 108.655366,12.076009 C108.655366,12.943522 108.455415,13.7126463 108.055512,14.383382 C107.65561,15.0541177 107.087495,15.5735676 106.351167,15.9417316 C105.614839,16.3098957 104.7706,16.4939777 103.818452,16.4939777 L100.206635,16.4939777 L100.206635,7.62630193 L103.920014,7.62630193 Z M103.74228,15.1546222 C104.690197,15.1546222 105.450857,14.8700357 106.024262,14.3008625 C106.597667,13.7316893 106.88437,12.9858397 106.88437,12.0633136 C106.88437,11.1069334 106.595551,10.3515623 106.017915,9.79720036 C105.440278,9.24283838 104.66269,8.9656574 103.685151,8.9656574 L101.920503,8.9656574 L101.920503,15.1546222 L103.74228,15.1546222 Z"
              id="Shape"
              fill="#FEFEFE"
              fillRule="nonzero"
            ></path>
            <polygon
              id="Path"
              fill="#FEFEFE"
              fillRule="nonzero"
              points="116.751615 7.62630193 116.751615 8.9656574 112.733548 8.9656574 112.733548 11.2952472 116.580228 11.2952472 116.580228 12.6346027 112.733548 12.6346027 112.733548 15.1546222 116.840482 15.1546222 116.840482 16.4939777 111.019681 16.4939777 111.019681 7.62630193"
            ></polygon>
            <g id="health_and_safety_black_24dp-(3)">
              <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
              <path
                d="M10.5,13 L8,13 L8,10 L10.5,10 L10.5,7.5 L13.5,7.5 L13.5,10 L16,10 L16,13 L13.5,13 L13.5,15.5 L10.5,15.5 L10.5,13 Z M12,2 L4,5 L4,11.09 C4,16.14 7.41,20.85 12,22 C16.59,20.85 20,16.14 20,11.09 L20,5 L12,2 Z"
                id="Shape"
                fill="#FFFFFF"
                fillRule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

const HIPAABadgeSolid = React.forwardRef(SvgHIPAABadgeSolid);
export default HIPAABadgeSolid;
